<template>
    <div class="d-flex align-center justify-center fill-height login-wrapper">
        <v-form
            @submit.prevent="send"
            ref="form"
            :disabled="loading"
            class="login-form-container"
        >
            <div class="text-center mb-6">
                <v-img
                    :src="require('@/assets/logo.png')"
                    max-width="260"
                    max-height="75"
                    class="mx-auto mb-3"
                    contain
                />
                <p class="text-subtitle-2 text--secondary font-weight-medium">Панель управления</p>
            </div>
            
            <v-card width="400" :loading="loading" :disabled="loading" class="login-card">
                <v-card-title class="justify-center">Вход в систему</v-card-title>
                <v-card-text class="pt-4">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                label="Логин"
                                :rules="req"
                                v-model="username"
                                prepend-inner-icon="$account"
                                outlined
                                dense
                                hide-details="auto"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="12">
                            <v-text-field
                                label="Пароль"
                                :rules="req"
                                v-model="password"
                                type="password"
                                prepend-inner-icon="$lock"
                                outlined
                                dense
                                hide-details="auto"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="px-6 pb-6 pt-2">
                    <v-btn type="submit" block large color="primary" class="font-weight-bold">
                        Войти
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template> 

<script>
export default {
    name: "Login",
    data: () => ({
        username: "",
        password: "",
        loading: false,
    }),
    mounted() {
        if (this.$store.state.auth.token) {
            this.$router.push({ name: "News" });
        }
    },
    methods: {
        async send() {
            if (!this.$refs.form.validate()) {
                return;
            }
            this.loading = true;
            try {
                const { token } = await this.$api("/login", {
                    method: "POST",
                    body: {
                        username: this.username,
                        password: this.password,
                    },
                });
                this.$store.commit("auth/token", token);
                this.$router.push({ name: "News" });
            } catch (e) {
                this.$error(e.message);
            }
            this.loading = false;
        },
    },
    computed: {
        req: () => [(v) => !!v || "Заполните поле"],
    },
};
</script>

<style scoped lang="scss">
.login-wrapper {
    min-height: 100vh;
    width: 100%;
    background-color: var(--v-background-base);
}
.brand-title {
    color: var(--v-primary-base);
    letter-spacing: -0.5px;
}
.login-card {
    border: 1px solid #e2e8f0 !important;
    border-radius: 16px !important;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.03) !important;
    
    .v-card__title {
        background-color: #f8fafc !important;
        border-bottom: 1px solid #e2e8f0 !important;
        color: var(--v-primary-base) !important;
        font-weight: 700;
        font-size: 1.2rem;
    }
}
</style>

